import { Icon } from '@rbilabs/universal-components';
import { Pressable, StyleSheet } from 'react-native';

import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';
import { primitive, spacing } from 'styles/constants';

const BUTTON_SIZE = 44;

export const TakeoverReplayButton = ({ onReplay }: { onReplay: () => void }) => {
  return (
    <Pressable
      onPress={() => {
        logButtonClick({
          attributes: {
            component: ClickEventComponentNames.BUTTON,
            name: 'Replay takeover video',
          },
        });
        onReplay();
      }}
      style={styles.replayButton}
      accessibilityRole="button"
      accessibilityLabel="Replay video"
      aria-label="Replay video"
      hitSlop={{ top: 12, bottom: 12, left: 12, right: 12 }}
    >
      <Icon variant="refresh" size="$5" color={primitive.$bbqBrown} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  replayButton: {
    position: 'absolute',
    right: spacing.$4,
    bottom: spacing.$4,
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    borderRadius: 22,
    backgroundColor: primitive.$mayoEggWhite,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: primitive.$bbqBrown,
  },
});
